import { HttpResponse } from '@angular/common/http';
import { Component, Inject, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { forkJoin, Observable } from 'rxjs';
import { LocationsService } from '../../locations.service';
import { IDoorOpenDialogData } from './door-open-dialog-data';
import { MatTableDataSource } from '@angular/material/table';
import { MatAutocomplete } from '@angular/material/autocomplete';
import { MatPaginator } from '@angular/material/paginator';
import { IDeviceDto } from '../device-dto';
import { DeviceService } from '../../../../shared/services/device.service';
import { AccountService } from '../../../../core/auth/account.service';
import { AlertService } from '../../../../shared/alert/alert.service';

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-door-open-dialog',
  standalone: false,
  templateUrl: './door-open-dialog.component.html',
  styleUrls: ['./door-open-dialog.component.scss'],
})
export class DoorOpenDialogComponent implements OnInit {
  devices: IDeviceDto[] = [];
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();
  loadingDevices: string[] = []; // Track which devices are being opened

  /**
   * Number of grid columns the dialog should size itself to.
   * 1 device -> narrow dialog, 2-3 -> wider rows, 4+ -> capped at 3 columns
   * so many devices wrap into a compact, scannable grid instead of one long
   * scrolling column.
   */
  get displayCols(): number {
    const count = this.devices?.length ?? 0;
    return Math.min(Math.max(count, 1), 3);
  }

  @ViewChild('openDoorDialogPaginator') paginator: MatPaginator | undefined;
  @ViewChild(MatAutocomplete) matAutocomplete: MatAutocomplete | undefined;
  displayedColumns: string[] = ['name', 'buttonOpenDoor'];
  constructor(
    public dialogRef: MatDialogRef<DoorOpenDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IDoorOpenDialogData,
    public locationsService: LocationsService,
    public deviceService: DeviceService,
    private alertService: AlertService,
    private accountService: AccountService
  ) {}

  ngOnInit(): void {
    console.log('DoorOpenDialogComponent initialized');
    console.log('Data received:', this.data);
    // Ensure userId is resolved consistently before actions
    if (!this.data.userId) {
      this.accountService.identity(true).subscribe((res: any) => {
        if (res?.id) {
          this.data.userId = String(res.id);
          console.log('Dialog resolved jhiUserId from identity (res.id):', this.data.userId);
        } else {
          console.warn('Dialog could not resolve userId on init');
        }
      });
    }
    // Seed with a mock device so UI shows an actionable button during restyle
    if (!this.devices || this.devices.length === 0) {
      this.devices = this.getMockDevices();
      this.data.devices = this.devices;
      this.dataSource = new MatTableDataSource<IDeviceDto>(this.devices);
    }

    this.loadAll();
  }

  loadAll(): void {
    forkJoin([this.loadDevices(this.data.location)]).subscribe({
      next: (res) => {
        const loaded = res[0].body ?? [];
        // If backend returns devices, use them; otherwise keep the mock
        this.devices = loaded.length ? loaded : this.devices;
        this.data.devices = this.devices;
        this.dataSource = new MatTableDataSource<IDeviceDto>(this.devices);
        setTimeout(() => {
          if (this.paginator) {
            this.dataSource.paginator = this.paginator;
          }
        });
      },
      error: (error) => {
        console.error('Error loading devices:', error);
        // On error, keep existing (mock) devices for UI testing
        this.devices = this.devices && this.devices.length ? this.devices : this.getMockDevices();
        this.data.devices = this.devices;
        this.dataSource = new MatTableDataSource<IDeviceDto>(this.devices);
      },
    });
  }

  loadDevices(locationId: string): Observable<HttpResponse<IDeviceDto[]>> {
    return this.locationsService.getDevicesByLocationId(locationId);
  }

  private getMockDevices(): IDeviceDto[] {
    return [
      {
        id: 'mock-device-1',
        name: 'Main Entrance',
      } as IDeviceDto,
    ];
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  openDoor(deviceId: string): void {
    console.log('openDoor method called with deviceId:', deviceId);
    console.log('data.location:', this.data.location);
    console.log('data.userId:', this.data.userId);

    // Do not proceed without a valid userId
    const userId = this.data.userId;
    if (!userId) {
      console.error('Cannot open door: userId is missing');
      return;
    }

    if (this.data.location && deviceId) {
      // Add device to loading state
      this.loadingDevices.push(deviceId);

      // Get device name once for better performance
      const device = this.devices.find((d) => d.id === deviceId);
      const deviceName = device ? device.name : 'Uređaj';

      console.log('Opening door with payload:', {
        deviceId,
        jhiUserId: userId,
        locationId: this.data.location,
      });

      this.deviceService.openDoor(this.data.location, userId, deviceId).subscribe({
        next: (res) => {
          // Remove from loading state on success
          this.loadingDevices = this.loadingDevices.filter((id) => id !== deviceId);
          console.log('Door opened successfully:', res);

          // Show success notification
          this.alertService.success(
            `${deviceName} - vrata su uspešno otvorena`,
            'records.doorOpenSuccess'
          );
        },
        error: (error) => {
          // Remove from loading state on error
          this.loadingDevices = this.loadingDevices.filter((id) => id !== deviceId);
          console.error('Error opening door:', error);

          // Show error notification
          this.alertService.error(
            `${deviceName} - greška pri otvaranju vrata`,
            'records.doorOpenError'
          );
        },
      });
    }
  }
}
